<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">

			<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
				<div style="text-align: center;">
					<h4 style="font-weight: bold; margin-bottom: 10px">{{$store.state.lang.text.balance_info[$store.state.lang.language]}}</h4>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom: 18px">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp">
							<label for="balance">{{$store.state.lang.text.balance[$store.state.lang.language]}}</label>
							<input id="balance" type="text" disabled="disabled" :value="config.moneylify(user.balance)" :placeholder="$store.state.lang.text.balance[$store.state.lang.language]">
						</div>
					</form>
				</div>
			</div>

			<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50" style="margin-bottom: 18px">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp">
							<label for="balance">
								{{$store.state.lang.text.balanceSport[$store.state.lang.language]}}
								<span style="font-size: 11px" v-if="user.sport_balance_lock > 0 && user.sport_balance > 0">(សូមភ្នាល់ {{config.moneylify(user.sport_balance_lock)}} ដើម្បីផ្ទេរប្រាក់)</span>
								<span style="font-size: 11px" v-else-if="user.sport_balance > 0">(អាចផ្ទេរប្រាក់)</span>
							</label>
							<input id="balance" type="text" disabled="disabled" :value="config.moneylify(user.sport_balance)" :placeholder="$store.state.lang.text.balance[$store.state.lang.language]">
						</div>
					</form>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50" style="margin-bottom: 18px">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp">
							<label for="balance">
								{{$store.state.lang.text.balanceESport[$store.state.lang.language]}}
								<span style="font-size: 11px" v-if="user.esport_balance_lock > 0 && user.esport_balance > 0">(សូមភ្នាល់ {{config.moneylify(user.esport_balance_lock)}} ដើម្បីផ្ទេរប្រាក់)</span>
								<span style="font-size: 11px" v-else-if="user.esport_balance > 0">(អាចផ្ទេរប្រាក់)</span>
							</label>
							<input id="balance" type="text" disabled="disabled" :value="config.moneylify(user.esport_balance)" :placeholder="$store.state.lang.text.balance[$store.state.lang.language]">
						</div>
					</form>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50" style="margin-bottom: 18px">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp">
							<label for="balance">
								{{$store.state.lang.text.balanceCasino[$store.state.lang.language]}}
								<span style="font-size: 11px" v-if="user.casino_balance_lock > 0 && user.casino_balance > 0">(សូមភ្នាល់ {{config.moneylify(user.casino_balance_lock)}} ដើម្បីផ្ទេរប្រាក់)</span>
								<span style="font-size: 11px" v-else-if="user.casino_balance > 0">(អាចផ្ទេរប្រាក់)</span>
							</label>
							<input id="balance" type="text" disabled="disabled" :value="config.moneylify(user.casino_balance)" :placeholder="$store.state.lang.text.balance[$store.state.lang.language]">
						</div>
					</form>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50" style="margin-bottom: 18px">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp">
							<label for="balance">
								{{$store.state.lang.text.balanceFishing[$store.state.lang.language]}}
								<span style="font-size: 11px" v-if="user.fishing_balance_lock > 0 && user.fishing_balance > 0">(សូមភ្នាល់ {{config.moneylify(user.fishing_balance_lock)}} ដើម្បីផ្ទេរប្រាក់)</span>
								<span style="font-size: 11px" v-else-if="user.fishing_balance > 0">(អាចផ្ទេរប្រាក់)</span>
							</label>
							<input id="balance" type="text" disabled="disabled" :value="config.moneylify(user.fishing_balance)" :placeholder="$store.state.lang.text.balance[$store.state.lang.language]">
						</div>
					</form>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50" style="margin-bottom: 18px">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp">
							<label for="balance">
								{{$store.state.lang.text.balanceSlot[$store.state.lang.language]}}
								<span style="font-size: 11px" v-if="user.slot_balance_lock > 0 && user.slot_balance > 0">(សូមភ្នាល់ {{config.moneylify(user.slot_balance_lock)}} ដើម្បីផ្ទេរប្រាក់)</span>
								<span style="font-size: 11px" v-else-if="user.slot_balance > 0">(អាចផ្ទេរប្រាក់)</span>
							</label>
							<input id="balance" type="text" disabled="disabled" :value="config.moneylify(user.slot_balance)" :placeholder="$store.state.lang.text.balance[$store.state.lang.language]">
						</div>
					</form>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50" style="margin-bottom: 18px">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp">
							<label for="balance">
								{{$store.state.lang.text.balanceKeno[$store.state.lang.language]}}
								<span style="font-size: 11px" v-if="user.keno_balance_lock > 0 && user.keno_balance > 0">(សូមភ្នាល់ {{config.moneylify(user.keno_balance_lock)}} ដើម្បីផ្ទេរប្រាក់)</span>
								<span style="font-size: 11px" v-else-if="user.keno_balance > 0">(អាចផ្ទេរប្រាក់)</span>
							</label>
							<input id="balance" type="text" disabled="disabled" :value="config.moneylify(user.keno_balance)" :placeholder="$store.state.lang.text.balance[$store.state.lang.language]">
						</div>
					</form>
				</div>
			</div>
			<!-- <div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50" style="margin-bottom: 18px">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp">
							<label for="balance">
								{{$store.state.lang.text.balanceCock[$store.state.lang.language]}}
								<span style="font-size: 11px" v-if="user.cock_balance_lock > 0 && user.cock_balance > 0">(សូមភ្នាល់ {{config.moneylify(user.cock_balance_lock)}} ដើម្បីផ្ទេរប្រាក់)</span>
								<span style="font-size: 11px" v-else-if="user.cock_balance > 0">(អាចផ្ទេរប្រាក់)</span>
							</label>
							<input id="balance" type="text" disabled="disabled" :value="config.moneylify(user.cock_balance)" :placeholder="$store.state.lang.text.balance[$store.state.lang.language]">
						</div>
					</form>
				</div>
			</div> -->
			<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
				<div style="text-align: center;">
					<h4 style="font-weight: bold; margin-bottom: 10px">{{$store.state.lang.text.transfer_to_main[$store.state.lang.language]}}</h4>
				</div>
			</div>

			<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
				<div class="verification__box">
					<div class="attach__wrap">
						 <select v-model="transfer.wallet_id">
							   <option value="">សូមជ្រើសរើសគណនី</option>
								<option value="1">គណនី Sport</option>
								<option value="2">គណនី eSport</option>
								<option value="3">គណនី Live Casino</option>
								<option value="4">គណនី Slot</option>
								<option value="5">គណនី Fishing</option>
								<option value="6">គណនី Keno</option>
								<!-- <option value="7">គណនី Cockfighting</option> -->
						 </select>
					</div>
			  </div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom: 18px">
				<div class="form__tabs__wrap">
					<form>
						<div class="form__grp"><input type="number" v-model="transfer.amount" :placeholder="$store.state.lang.text.transfer_amount[$store.state.lang.language]"></div>
					</form>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
				<div class="form__tabs__wrap">
					<form>
						<div class="create__btn"><a class="cmn--btn" @click="requestTransfer()" style="margin-top: 5px"><span>{{$store.state.lang.text.transfer[$store.state.lang.language]}}</span></a></div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	import { Datetime } from 'vue-datetime';

	export default {
		components: {

		},
		mounted() {
			window.scrollTo(0,0);
		},
		created() {
			this.getUser();
			// this.getPayment();
		},
		watch: {
			'transfer.amount': function() {
				this.validateBalance();
			},
			'transfer.wallet_id': function() {
				this.validateBalance();
			}
		},
		methods: {
			validateBalance() {
				if(String(this.transfer.wallet_id).length > 0) {
					let currentWalletBalance = 0;
					switch (this.transfer.wallet_id) {
						case "1":
							currentWalletBalance = this.user.sport_balance
							break;
						case "2":
							currentWalletBalance = this.user.esport_balance
							break;
						case "3":
							currentWalletBalance = this.user.casino_balance
							break;
						case "4":
							currentWalletBalance = this.user.slot_balance
							break;
						case "5":
							currentWalletBalance = this.user.fishing_balance
							break;
						case "6":
							currentWalletBalance = this.user.keno_balance
							break;
						case "7":
							currentWalletBalance = this.user.cock_balance
							break;
					}
					if(parseFloat(this.transfer.amount) > parseInt(parseFloat(currentWalletBalance) * 100) / 100) {
						this.transfer.amount = parseInt(parseFloat(currentWalletBalance) * 100) / 100;
					}
				}
			},
			getUser() {
				this.$http.get(this.config.api + "/user/authed/user/get_balance").then(res => {
					if (res.body.status == 'success') {
						this.loaded = true;
						this.user = res.body.data
					}
				})
			},
			requestTransfer() {
				if(String(this.transfer.wallet_id).length > 0 && String(this.transfer.amount).length > 0) {
					this.$store.state.authentication.loading = true;
					this.$http.post(this.config.api + "/user/authed/payment/transfer", {
						wallet_id: this.transfer.wallet_id,
						amount: this.transfer.amount
					}).then(res => {
						this.$store.state.authentication.loading = false;
						if (res.body.status == 'success') {
							this.getUser();
							this.$notification.notify(this.$store.state.lang.text.transfer_success[this.$store.state.lang.language]);
							this.transfer.wallet_id = "";
							this.transfer.amount = "";
						}
					})
				}
			}
		},
		computed: {
		},
		data() {
			return {
				select: "",
				copied: false,
				user: {
					hash: "",
					username: "",
					name: "",
					phone: "",
					balance: 0,
					sport_balance: 0,
					sport_balance_lock: 0,
					esport_balance: 0,
					esport_balance_lock: 0,
					casino_balance: 0,
					casino_balance_lock: 0,
					fishing_balance: 0,
					fishing_balance_lock: 0,
					slot_balance: 0,
					slot_balance_lock: 0,
					keno_balance: 0,
					keno_balance_lock: 0,
					cock_balance: 0,
					cock_balance_lock: 0
				},
				transfer: {
					wallet_id: "",
					amount: ""
				},
				method_withdraw: [],
				loaded: false
			}
		}
	}
</script>
<style>
	.account-list-menu {
		cursor:pointer; background-color: #103037; border-radius: 15px;padding: 15px; margin-bottom: 15px
	}
	.account-list-menu:nth-child(odd) {
		min-width: calc(30% - 15px) !important;
		max-width: calc(30% - 15px) !important;
		margin-right: 15px !important;
	}
	@media (max-width: 1264px) {
		.account-list-menu:nth-child(odd) {
			min-width: calc(40% - 15px) !important;
			max-width: calc(40% - 15px) !important;
			margin-right: 15px !important;
		}
	}
	@media (max-width: 944px) {
		.account-list-menu:nth-child(odd) {
			min-width: calc(50% - 15px) !important;
			max-width: calc(50% - 15px) !important;
			margin-right: 15px !important;
		}
	}
	.account-active {
		background-color: #20283F;
	}

</style>



// WEBPACK FOOTER //
// src/pages/Account/Balance.vue